import FontFaceObserver from 'fontfaceobserver';

export const initFontLoader = () => {
  const font = new FontFaceObserver('Inter'); // update to your actual font
  font.load().then(() => {
    document.documentElement.classList.add('fonts-loaded');
  });
};
